import { render, staticRenderFns } from "./DescargarInformeControlAcceso.vue?vue&type=template&id=48218695"
import script from "./DescargarInformeControlAcceso.vue?vue&type=script&lang=js"
export * from "./DescargarInformeControlAcceso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports